import styled from 'styled-components';
import { mainTheme } from '@plecto/ui';

const Separator = styled.div`
	height: 1px;
	margin: 9px 0;
	overflow: hidden;
	background-color: ${mainTheme.border.decorative};
	margin: 5px 0;
`;

export default Separator;
